<div class="upsell-wait">
  <div class="upsell-wait__container mx-auto p-4">
    <div class="upsell-wait__row rounded-lg flex flex-col desktop:flex-row items-center p-4 gap-4 desktop:gap-10" [ngClass]="{'color_background' : isFull }">

      <div class="upsell-wait__iconBlock rounded-lg flex flex-row items-center gap-4" [ngClass]="{'color_background' : !isFull }">
        <img class="upsell-wait__icon" src="{{ iconWait }}" alt="">
        <p class="upsell-wait__iconText uppercase" >{{ iconText }}</p>
      </div>

      <div class="upsell-wait__description text-center desktop:text-left">
        <h3 class="text-2xl mb-1" [innerHTML]="title"></h3>
        <p class="" [innerHTML]="description"></p>
      </div>

    </div>
  </div>
</div>